<!-- 搜索栏 -->
<template>
  <div id="search">
    <div class="top">
      <div class="search">
        <span>捐赠查询</span>
        <el-input placeholder="SN/捐赠人" v-model="keyword" class="input-with-select" @keyup.enter.native="handleSearch">
          <!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
            <el-option label="餐厅名" value="1"></el-option>
            <el-option label="订单号" value="2"></el-option>
            <el-option label="用户电话" value="3"></el-option>
          </el-select> -->
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    handleSearch () {
      this.$router.push({ path: this.redirect || '/search/' + this.keyword })
    }
  }
}
</script>

<style lang="less">
  #search {
    .top {
      height: 128px;
      background: #0d0d0d;
      overflow: hidden;
      .search {
        height: 44px;
        width: 769px;
        background: #0d0d0d;
        margin: 0 auto;
        margin-top: 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 20px;
          color: #ff7800;
        }
        .el-input-group {
          width: 80% !important;
        }
        .el-input-group__append {
          background-color: #ff7800 !important;
          color: #fff !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue